export const SORT_FIELD_POPULARITY = 'popularity'
export const SORT_ORDER_ASCENDING = 'ascending'
export const SORT_ORDER_DESCENDING = 'descending'
export const WAS_PAYMENT_PAGE_AUTHENTICATED = 'wasPaymentPageAuthenticated'
